export const STORE_COVER_ACCEPTED_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp'];
export const STORE_COVER_ACCEPT_STRING = '.jpg,.jpeg,.png,.webp';
export const STORE_COVER_MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024; // 5MB
export const STORE_COVER_WIDTH = 2432;
export const STORE_COVER_HEIGHT = 512;
export const STORE_COVER_ASPECT_RATIO = STORE_COVER_WIDTH / STORE_COVER_HEIGHT;

export const STORE_COVER_MIN_WIDTH = 1216;
export const STORE_COVER_MIN_HEIGHT = 256;

export const STORE_COVER_RECOMMENDED_SIZE = `${STORE_COVER_WIDTH} × ${STORE_COVER_HEIGHT}`;
export const STORE_COVER_MIN_SIZE = `${STORE_COVER_MIN_WIDTH} × ${STORE_COVER_MIN_HEIGHT}`;
